<script lang="ts">
  export let title: string
  export let text: string
</script>

<div class="container-fluid py-section">
  <div class="container-xxl">
    <h2 class="mb-0">{title}</h2>
    <div class="mt-4">
      {@html text}
    </div>
  </div>
</div>
